import { LinkSimple, Prohibit } from "@phosphor-icons/react";
import ModalCloseButton from "../ui/ModalCloseButton";
import LoaderLoop from "../shared/loader/LoaderLoop";
import "./GrowIntegration.css";

/**
 * GrowCancelLinkPrompt — shown by useCancelGrowLinkOnManualPayment when a
 * transaction being marked paid/cancelled by hand still has an ACTIVE Grow link.
 */
export default function GrowCancelLinkPrompt({ link, reason = "paid", busy, canCancel, onCancelAndContinue, onBack }) {
  const sum = Number(link?.sum || 0).toLocaleString("he-IL", { maximumFractionDigits: 2 });
  const isCancel = reason === "cancel";
  return (
    <div className="grow-overlay" onClick={onBack} role="presentation">
      <div className="grow-modal grow-modal-sm" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="grow-clp-title">
        <div className="grow-modal-header">
          <div className="grow-modal-title">
            <span className="grow-modal-icon"><LinkSimple size={20} weight="fill" /></span>
            <div>
              <span className="grow-eyebrow">Grow</span>
              <h3 id="grow-clp-title">קישור תשלום פעיל</h3>
            </div>
          </div>
          <ModalCloseButton onClick={onBack} />
        </div>
        <div className="grow-modal-body">
          <p>
            לתשלום הזה קיימת דרישת תשלום Grow על ₪{sum} שעדיין פעילה, ולכן הוא נעול לעדכון ידני.{" "}
            {isCancel
              ? "כדי לבטל את החוב כאן יש לבטל קודם את דרישת התשלום, אחרת המטופל עדיין יוכל לשלם דרכה."
              : "כדי לעדכן אותו ידנית יש לבטל קודם את דרישת התשלום, אחרת התשלום עלול להיגבות פעמיים."}
          </p>
          <p className="grow-note">
            {canCancel
              ? "ביטול דרישת התשלום מבטל את הקישור ב-Grow; אחרי זה אפשר לנהל את התשלום ידנית."
              : "רק מי שמורשה לגבות דרך Grow יכול לבטל את דרישת התשלום."}
          </p>
        </div>
        <div className="grow-modal-footer">
          <div className="grow-footer-actions">
            <button type="button" className="grow-btn ghost" onClick={onBack} disabled={busy}>חזרה</button>
            {canCancel && (
              <button type="button" className="grow-btn primary" onClick={onCancelAndContinue} disabled={busy}>
                {busy ? <LoaderLoop size="xs" /> : <Prohibit size={16} />} ביטול דרישת התשלום והמשך
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
